<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-button type="primary" size="mini" @click="add">新增</el-button>
				<el-tabs v-model="activeName" @tab-click="handleClick" type="border-card"
					style="margin-top: 10px;height: 650px;">	
					<el-tab-pane :label="item.type" :name="item.type" v-for="(item,index) in data" :key="index">
						<div class="materialupload" style="box-sizing: border-box;padding: 10px;">
							<upload ref="upload" :value="item.file" :formCreateInject="true" :canupload="false" />
						</div>
					</el-tab-pane>	
				</el-tabs>
			</template>
			<template #footer>
				<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
		<add ref="add" @submit="addSubmit" />
	</div>
</template>
<style>
	.materialupload .el-upload-list__item {
		width: 200px !important;
		height: 200px !important;
	}
	.materialupload .el-upload {
		width: 200px !important;
		height: 200px !important;
	}
	.materialupload .el-upload-dragger {
		width: 200px !important;
		height: 200px !important;
	}
</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	import add from '../add/index.vue'
	export default {
		mixins: [modalMixins],
		props: {
			row: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				activeName: '',
				modal_width: 1000,
				modal_height: 800,
				modal_title: '上传产品文档',
				data: []
			}
		},
		created() {

		},
		mounted() {
			// this.$refs.upload.beforeDownload = (file) => {
			// 	file.forEach((item) => {
			// 		console.log(item)
			// 		item.name = '下载测试'
			// 	})
			// }
		},
		watch: {

		},
		computed: {

		},

		methods: {
			modal_init() {
				let obj = {}
				obj.goodsUid = this.row.goodsUid
				obj.specUid = this.row.specUid	
				this.$api.material.getMaterial(obj).then((res) => {
					if(res && res.file){
						this.data = res.file
						this.activeName = this.data[0].type
					}else{
						this.data = []
						this.activeName = ''
					}
		
				})
			},
			// afterUploadOss(e){
			// 	e.name = '123.'+ e.type.toLowerCase()
			// },
			modal_onhide(){
				this.data = []
				this.activeName = ''
			},
			modal_hide() {
				this.$emit('modalhide')
			},
			handleClick() {

			},
			submit() {
				let obj = {}
				obj.file = this.data
				obj.goodsUid = this.row.goodsUid
				obj.goodsCode = this.row.goodsCode
				obj.specUid = this.row.specUid
				obj.specCode = this.row.specCode		
				this.$api.material.addMaterial(obj).then(() => {
					this.$emit('success')
					this.$message.success('操作成功')
					this.modal_cancel()
				})
			},
			add(){
				this.$refs.add.modal_show()
			},
			addSubmit(e) {			
				if(e.file && e.file.length!=0){
					e.file.forEach((item)=>{
						let arr = item.name.split('.')
						item.name = e.name + '.' + arr[1]
					})
					let buff = true
					this.data.forEach((item)=>{
						if(item.type==e.type){
							item.file = item.file.concat(e.file)
							buff = false
						}
					})
					if(buff){				
						this.data.push(e)
					}
					this.activeName = e.type
				}
				
			}
		},
		components: {
			upload,
			add
		}
	}
</script>